module.exports = __webpack_public_path__ + "img/item_img.ea28808d.jpg";